export default __webpack_public_path__ + "static/media/31.716e42a2.jpg";